import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CashPositionsActions } from './cash-positions.actions';
import { CashPositionService } from '../../services/cash-position.service';

@Injectable()
export class CashPositionsEffects {
  private actions$ = inject(Actions);
  private svc = inject(CashPositionService);

  loadAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CashPositionsActions.loadCashPositions),
      mergeMap(() => this.svc.getAll().pipe(
        map(positions => CashPositionsActions.loadCashPositionsSuccess({ positions })),
        catchError(err => of(CashPositionsActions.loadCashPositionsFailure({ error: err.message })))
      ))
    )
  );
}
